/* eslint-disable react-hooks/exhaustive-deps */
import { SaveAlt, Search } from "@material-ui/icons";
import { Fab, Grid, Tooltip } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import SelectProvinceType from "components/select-province-type/SelectProvinceType";
import { useFormik } from "formik";
import * as Yup from "yup";

const ReportExtensionFilter = ({ onSubmit, onExport, disabledExport }) => {
  const formik = useFormik({
    initialValues: {
      dateRange: [new Date(), new Date()],
      typeProvince: "",
      code: [],
      contactCenters: null,
    },
    validationSchema: Yup.object().shape({
      typeProvince: Yup.string().required("Không được trống"),
      code: Yup.array().min(1, "Không được trống"),
    }),
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <DateRangePicker
            value={formik.values.dateRange}
            onChange={(value) => formik.setFieldValue("dateRange", value)}
          />
        </Grid>

        <Grid item xs={5}>
          <SelectProvinceType formik={formik} />
        </Grid>

        <Grid item xs={2}>
          <Tooltip title="Tìm kiếm">
            <Fab color="primary" aria-label="Search" type="submit">
              <Search />
            </Fab>
          </Tooltip>
          <Tooltip title="Tải báo cáo">
            <Fab
              color="primary"
              aria-label="Search"
              style={{ marginLeft: "10px" }}
              disabled={disabledExport}
              onClick={onExport}>
              <SaveAlt />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default ReportExtensionFilter;
